<template>
    <v-container fluid :class="{isActive: active}">
        <v-layout row wrap>
            <v-flex sm12 md6 xl3>
                <div :class="isActiveSegment">
                    <h1 :class="h1">{{Segment.Title}}</h1>
                    <p>{{Segment.ContentDescription}}</p>
                </div>
            </v-flex>
            
            <v-flex 
                sm12 md6 xl3 pa-2
                v-for="content in Content"
                :key="content.Path"
            >
                <content-card 
                    :Content="content"
                ></content-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import Insights from '../models/Insights'
import ContentCard from './Content.Card'

export default {
    props:{
        Segment:Object,
        Content:Array
    },
    components:{
        ContentCard
    },
    computed:{
        active(){
            return this.Segment.SegmentKey === Insights.nav.Segment.active;
        },
        isActiveSegment(){
            return this.active ? "secondary--text" : "";
        },
        h1(){
            let _css = "display-1 ";
            _css += (this.active) ? "font-weight-heavy" : "font-weight-light";
            return _css;
        }
    },
    data(){
        return {
            //
            m:{
                term:[],
                terms:[
                    "F","G"
                ]
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.isActive{
    background-color: var(--v-accent-darken3)
}
hr{
    border-top:1px solid #E0E0E0;
    border-bottom:0px
}
</style>
